import { useCallback } from 'react';

import { type DealerBoothPublicDto, DealerPrimaryContactMethod } from '@furality/fox-client/models';
import fox from '#/api/fox.ts';

export const hasContactMethod = (
  dealer: DealerBoothPublicDto,
  contactMethod: DealerPrimaryContactMethod,
): boolean => {
  const contactMethodUrl = getContactMethodUrl(dealer, contactMethod);
  return !!contactMethodUrl;
};

export const getContactMethodUrl = (
  dealer: DealerBoothPublicDto,
  contactMethod: DealerPrimaryContactMethod,
): string | null => {
  switch (contactMethod) {
    case DealerPrimaryContactMethod.Discord:
      return dealer.discord;
    case DealerPrimaryContactMethod.Email:
      return dealer.email;
    case DealerPrimaryContactMethod.Telegram:
      return dealer.telegram;
    case DealerPrimaryContactMethod.Twitch:
      return dealer.twitch;
    case DealerPrimaryContactMethod.Twitter:
      return dealer.twitter;
    case DealerPrimaryContactMethod.Youtube:
      return dealer.youtube;
    case DealerPrimaryContactMethod.Website:
      return dealer.website;
    default:
      return null;
  }
};

/**
 * Helper wrapper around the POST that increments metrics for a booth's link clicks.
 * Skips the endpoint call if the url is null/undefined, also skips if dealerId is somehow negative.
 */
export const useUpdateDealerMetrics = () =>
  useCallback(async (dealerId: number, url: string) => {
    if (url && dealerId >= 0) {
      await fox.value.dealerTrackLinkRedirect({
        params: {
          boothId: dealerId,
        },
        body: { link: url },
      });
    }
  }, []);
